import { render, staticRenderFns } from "./ClassSearch.vue?vue&type=template&id=a564b2da&scoped=true&"
import script from "./classsearch.js?vue&type=script&lang=js&"
export * from "./classsearch.js?vue&type=script&lang=js&"
import style0 from "./ClassSearch.vue?vue&type=style&index=0&id=a564b2da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a564b2da",
  null
  
)

export default component.exports